// FacebookLoginButton.js
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { FACEBOOK_APP_ID } from "../config";
import { FaFacebookF } from "react-icons/fa";

const FacebookLoginButton = ({ handleLogin }) => {
  return (
    <FacebookLogin
      appId={FACEBOOK_APP_ID}
      autoLoad={false}
      fields="name,email,picture,birthday"
      callback={handleLogin}
      render={(renderProps) => (
        <button
          type="button"
          onClick={renderProps.onClick}
          className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-50 dark:bg-blue-500/10 text-[#1877F2] dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-500/20 transition-all duration-200 shadow-sm"
          title="Continue with Facebook"
        >
          <FaFacebookF size={18} />
        </button>
      )}
    />
  );
};

export default FacebookLoginButton;
